import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TempZone } from "~/lib/tempZone";

import { ProductResult } from "./ProductResult";

export const DEFAULT_REASON_CODE = "Cycle Counted";

type CycleCountsNewState = {
  page: number;
  searchedVariant: ProductResult | null;
  scannedBarcode: string | null;
  scanState: "error" | "success" | "ready";
  reasonCode: string;
  isQuantityDirty: boolean;
  tempZoneFilters: TempZone[];
};

const initialState: CycleCountsNewState = {
  page: 1,
  searchedVariant: null,
  scannedBarcode: null,
  scanState: "ready",
  reasonCode: DEFAULT_REASON_CODE,
  isQuantityDirty: false,
  tempZoneFilters: []
};

export const cycleCountsNewSlice = createSlice({
  name: "cycleCountsNew",
  initialState,
  reducers: {
    setPage(state, { payload }: PayloadAction<number>) {
      state.page = payload;
    },
    setSearchedVariant(
      state,
      { payload }: PayloadAction<ProductResult | null>
    ) {
      state.searchedVariant = payload;
    },
    setScannedBarcode(state, { payload }: PayloadAction<string | null>) {
      state.scannedBarcode = payload;
    },
    setScanState(
      state,
      { payload }: PayloadAction<"error" | "success" | "ready">
    ) {
      state.scanState = payload;
    },
    setReasonCode(state, { payload }: PayloadAction<string>) {
      state.reasonCode = payload;
    },
    setIsQuantityDirty(state, { payload }: PayloadAction<boolean>) {
      state.isQuantityDirty = payload;
    },
    setTempZoneFilters(state, { payload }: PayloadAction<TempZone[]>) {
      state.tempZoneFilters = payload;
    }
  }
});

export const {
  setPage,
  setSearchedVariant,
  setScannedBarcode,
  setScanState,
  setReasonCode,
  setIsQuantityDirty,
  setTempZoneFilters
} = cycleCountsNewSlice.actions;
